"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformResultToSavedResult = exports.savedResultItemsToNearbyProperties = exports.savedResultItemsToNearbyResultItems = void 0;
var propertyToPriceShort_1 = require("@/transformers/propertyToPriceShort");
exports.savedResultItemsToNearbyResultItems = function (favs, map) {
    var toNearby = function (fav) {
        return {
            name: fav.building,
            caption: propertyToPriceShort_1.toPrice(fav, map),
            position: fav.lat ? { lat: fav.lat, lng: fav.lng } : null,
            price: fav.price,
        };
    };
    return favs.map(toNearby);
};
exports.savedResultItemsToNearbyProperties = function (items, map, googleApikey) {
    var toNearby = function (item) {
        var staticMap = "https://maps.googleapis.com/maps/api/staticmap?center=" + item.lat + "," + item.lng + "&zoom=16&size=300x200&markers=color:0x00b0a8|" + item.lat + "," + item.lng + "&maptype=roadmap&style=feature:all|element:labels&key=" + googleApikey;
        return {
            id: item.referenceId,
            type: item.type,
            name: item.building,
            price: item.price,
            currency: map.find(function (it) { return it.key === item.currencyId; }).code,
            size: item.size,
            sizeUnit: item.sizeSaleable ? 'sa' : 'gfa',
            bed: item.amenities.find(function (it) { return it.key === 'bed'; }).value,
            bath: item.amenities.find(function (it) { return it.key === 'bath'; }).value,
            image: (item.images && item.images.length) ? item.images[0].path : staticMap,
            position: {
                lat: item.lat,
                lng: item.lng,
            },
            active: false,
        };
    };
    return items.filter(function (it) { return it.lat; }).map(toNearby);
};
exports.transformResultToSavedResult = function (results, currencyId) {
    return results.map(function (it) {
        return __assign(__assign({}, it), { currencyId: currencyId, available: true, userPropertyId: 0 });
    });
};
